var _g, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExtra(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Extra-Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13190",
    "data-name": "Group 13190",
    transform: "translate(-85.046 -357.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1003",
    "data-name": "Ellipse 1003",
    cx: 8.476,
    cy: 8.476,
    r: 8.476,
    transform: "translate(88.572 361.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13186",
    "data-name": "Group 13186"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1000",
    "data-name": "Ellipse 1000",
    cx: 7.283,
    cy: 7.283,
    r: 7.283,
    transform: "translate(89.764 362.261)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1000_-_Outline",
    "data-name": "Ellipse 1000 - Outline",
    d: "M7.283,0a7.283,7.283,0,1,0,7.283,7.283A7.283,7.283,0,0,0,7.283,0m0-.5A7.783,7.783,0,1,1-.5,7.283,7.792,7.792,0,0,1,7.283-.5Z",
    transform: "translate(89.764 362.261)",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1001",
    "data-name": "Ellipse 1001",
    cx: 6.118,
    cy: 6.118,
    r: 6.118,
    transform: "translate(90.929 363.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1001_-_Outline",
    "data-name": "Ellipse 1001 - Outline",
    d: "M6.118,0a6.118,6.118,0,1,0,6.118,6.118A6.118,6.118,0,0,0,6.118,0m0-.5A6.618,6.618,0,1,1-.5,6.118,6.625,6.625,0,0,1,6.118-.5Z",
    transform: "translate(90.929 363.426)",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1002",
    "data-name": "Ellipse 1002",
    cx: 4.953,
    cy: 4.953,
    r: 4.953,
    transform: "translate(92.095 364.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1002_-_Outline",
    "data-name": "Ellipse 1002 - Outline",
    d: "M4.953,0A4.953,4.953,0,1,0,9.905,4.953,4.953,4.953,0,0,0,4.953,0m0-.5A5.453,5.453,0,1,1-.5,4.953,5.459,5.459,0,0,1,4.953-.5Z",
    transform: "translate(92.095 364.592)",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5810",
    "data-name": "Path 5810",
    d: "M9.544,0a9.544,9.544,0,1,0,9.544,9.544A9.544,9.544,0,0,0,9.544,0Zm0,17.9A8.351,8.351,0,1,1,17.9,9.544,8.351,8.351,0,0,1,9.544,17.9Z",
    transform: "translate(87.502 360)",
    fill: "#65676a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5528",
    "data-name": "Path 5528",
    d: "M9.516.849",
    transform: "translate(91.984 359.984)",
    fill: "gray"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4499",
    "data-name": "Rectangle 4499",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5528-2",
    "data-name": "Path 5528",
    d: "M9.516.849",
    transform: "translate(1.984 2.984)",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExtra);
export default __webpack_public_path__ + "static/media/icon_extra.82527388decc1854f67136f1ef6511d0.svg";
export { ForwardRef as ReactComponent };